import styled from 'styled-components'
import { darkMode } from 'utilities/styled'
import { H3 } from 'components/typography/heading'

export const Wrapper = styled.dialog`
    --__huma-component-prompt-content-padding: 32px;

    position: fixed;
    inset: 0;

    border: unset;
    max-width: unset;
    width: 100vw;
    max-height: unset;
    height: 100dvh;
    padding: 0;
    background-color: transparent;

    &,
    & > div,
    &::backdrop {
        opacity: 0;
    }

    &::backdrop {
        --__huma-component-prompt-backdrop-alpha: .2;

        background-color: rgb(from var(--huma-palette-neutral-10) r g b / var(--__huma-component-prompt-backdrop-alpha));

        ${darkMode`
            --__huma-component-prompt-backdrop-alpha: .4;
        `}
    }

    &[open] {
        &,
        & > div,
        &::backdrop {
            opacity: 1;
        }
    }
`

export const Container = styled.div`
    display: grid;
    grid-template: 1fr / 1fr;
    place-items: center;

    overflow-y: auto;
    overscroll-behavior: contain;
    position: inherit;
    inset: inherit;
`

export const Content = styled.div`
    display: grid;
    grid-template-rows:
        [header] auto
        [body] minmax(0, 1fr)
        [footer] auto;
    grid-template-columns: minmax(0, 1fr);
    row-gap: 24px;

    margin: 10svh auto;
    border-radius: 8px;
    width: 336px;
    max-width: 90vw;
    height: max-content;
    max-height: 80svh;
    padding: 24px;
    background-color: var(--huma-color-surface-default);
    box-shadow:
        0 -4px 16px 0 var(--huma-color-shadow),
        var(--huma-shadow-high);

    color: var(--huma-color-foreground-default);

    &:not(:has(.prompt-body)) {
        grid-template-rows:
            [header] auto
            [footer] auto;

        & > form {
            grid-row: footer;
        }
    }

    ${darkMode`
        box-shadow:
            inset 0 0 0 1px var(--huma-color-border-default),
            0 -4px 16px 0 var(--huma-color-shadow),
            var(--huma-shadow-high);;
    `}

    ${Wrapper}[open] & {
        opacity: 1;
    }

    & > form {
        display: grid;
        grid-template-rows: subgrid;
        grid-row: body / span 2;
    }
`

export const PromptHeader = styled.header`
    grid-row: header;
`

export const Heading = styled(H3)`
    margin-block-end: 0;

    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const PromptBody = styled.article`
    grid-row: body;

    min-width: 0;

    > :last-child {
        margin-block-end: 0;
    }
`

export const PromptFooter = styled.footer`
    grid-row: footer;

    min-width: 0;

    > :first-child {
        margin-block-start: 0;
    }
`